
<agpr-overlay
    #overlay
    [initialFocusSelectors]="initialFocusSelectors"
    [isOpen]="isOpen"
    (isOpenChange)="popupOpenChange($event)" >

    <div agprOverlayTrigger>
        <ng-content></ng-content>
    </div>

    <ng-template agprOverlayTarget>
        <agpr-advanced-color-picker-popover
            [id]="id"
            [value]="colorModel"
            [showRecentColors]="showRecentColors?.show"
            [showFavoriteColors]="showFavoriteColors"
            [brandId]="brandId"
            [property]="showRecentColors?.property"
            (colorChange)="onPopoverColorSelected($event)"
            (favoriteColorsChange)="onfavoriteColorsChange($event)"
            (close)="onPopoverClose($event)"
            >
        </agpr-advanced-color-picker-popover>
    </ng-template>
</agpr-overlay>



